import { PaymentEventDateType, PaymentRefererType } from '../commons/PaymentFormStatus'

export const isEmpty = (input: string | null): boolean => {
  if (input == null || input.length === 0) {
    return true
  }
  return false
}

export const isValidEmail = (email: string | null): boolean => {
  if (email) {
    return /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)
  }
  return false
}

export const isValidPassword = (password: string | null): boolean => {
  if (password) {
    return /^[a-zA-Z0-9!-/:-@¥[-`{-~]{8,}$/i.test(password)
  }
  return false
}

export const isValidDate = (date: string | null): boolean => {
  if (date) {
    const formatTest = /^\d{4}\/\d{1,2}\/\d{1,2}$/.test(date)
    if (!formatTest) {
      return false
    }
    return !isNaN(Date.parse(date))
  }
  return false
}

export const validateSignupForm = (formData: any): { [key: string]: string } => {
  const { email, password } = formData

  if (!isValidEmail(email)) {
    return { email: 'メールアドレス形式が正しくありません。' }
  }
  if (!isValidPassword(password)) {
    return { password: 'パスワード形式が正しくありません。' }
  }
  return {}
}

export const validatePaymentForm = (formData: any): { [key: string]: string } => {
  const {
    familyName,
    firstName,
    completeCreditCard,
    selectedDateOption,
    eventDate,
    selectedRefererOption,
    otherReferer
  } = formData

  if (isEmpty(familyName) || isEmpty(firstName)) {
    return { name: '名前を入力してください。' }
  }
  if (!completeCreditCard) {
    return { creditCard: 'クレジットカード情報が正しくありません。' }
  }
  if (selectedDateOption === PaymentEventDateType.DETERMINED && !isValidDate(eventDate)) {
    return { eventDate: '開催日の入力形式が正しくありません。' }
  }
  if (selectedRefererOption === PaymentRefererType.OTHER && isEmpty(otherReferer)) {
    return { referer: 'Ennoshitaを知ったきっかけを入力してください。' }
  }
  return {}
}

export const isEmptyObject = (input: object | null): boolean => {
  if (input) {
    return !Object.keys(input).length
  }
  return true
}

export const validateResetPasswordForm = (formData: any): { [key: string]: string } => {
  const { newPassword } = formData

  if (!isValidPassword(newPassword)) {
    return { password: 'パスワード形式が正しくありません。' }
  }
  return {}
}
